import invStrat from '@/app/mixins/toolkit/invStrat/invStrat';

const diversification = {
  exp(asset) {
    return `a high exposure to a single investment in the ${asset.asset} asset class`;
  },
  prop(asset) {
    return `a high exposure to ${asset.asset}`;
  },
  comp(asset) {
    return `a high exposure to ${asset.asset} and within that, high exposure to a single asset`;
  },
};

export default {
  name: 'inv-strat',
  mixins: [invStrat],
  data: () => ({
    diversification,
  }),
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    invStrat() {
      return this.$store.getters['toolkit/getItemData'];
    },
    invStratMembers() {
      return this.invStrat.members;
    },
    isInvStratMembersAdditionalInfo() {
      if (this.invStrat.memberInfo === true
        && this.invStratMembers !== undefined
        && this.invStratMembers.length > 0
      ) {
        return this.invStratMembers[0].additionalInfo !== undefined
          && this.invStratMembers[0].additionalInfo.length !== 0
          && this.invStratMembers[0].additionalInfo.currentWorkStatus.value !== '';
      }
      return false;
    },
    invStratMembersAdditionalInfo() {
      return (member) => {
        const keys = Object.keys(member.additionalInfo);
        return keys.flatMap(key => ({
          key: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
          value: member.additionalInfo[key],
        }));
      };
    },
    anyMemberMakingRegularContributions() {
      return this.invStratMembers.filter(member => member.additionalInfo.contributionPlans.value === 'making regular contributions every year').length > 0;
    },
    allMembersNotReceivingPensionInNearTerm() {
      return this.invStratMembers.filter(member => member.additionalInfo.incomeNeeds.value === 'not receiving a pension and one is unlikely to start in the near term').length === this.invStratMembers.length;
    },
    allMembersUnlikelyDependOnIncome() {
      return this.invStratMembers.filter(member => member.additionalInfo.longTermIncomeNeeds.value === 'unlikely to depend on income from the Fund in retirement').length === this.invStratMembers.length;
    },
    formatMembers() {
      return (this.fund.members.flatMap(member => `${member.firstName} ${member.lastName}`)).join(', ');
    },
    formatTrustees() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`)).join(', ');
    },
    hasOtherAssets() {
      return this.invStrat.assets.findIndex(asset => asset.name === 'Other') !== -1;
    },
    otherAssets() {
      if (this.hasOtherAssets) {
        return this.invStrat.assets.filter(asset => asset.name === 'Other')[0];
      }
      return {
        assets: [],
      };
    },
    formatOtherAssets() {
      const otherAssets = this.otherAssets.assets.flatMap(asset => asset.name);
      return otherAssets.join(', ');
    },
    otherAssetCollectable() {
      return this.otherAssets.assets.findIndex(asset => asset.collectable === 'yes') !== -1;
    },
  },
  methods: {
    formatDOB(dob) {
      const dateOfBirth = new Date(dob);
      return dateOfBirth.toLocaleDateString('en-AU');
    },
  },
};
